<template>
    <div class="availibility-status-container" @click="statusClicked">
        <div :class="avaibilityStatusBoxClass">
            <common-icon name="white-check" size="small"></common-icon>
        </div>
        <div class="availability-status-text">
            {{ label }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            label: { type: String, required: true },
            type: { type: String, required: true },
        },

        data() {
            return {
                showCancelled: false,
            }
        },

        computed: {
            avaibilityStatusBoxClass() {
                return {
                    'availability-status-box': true,
                    [`availability-status-box--${this.type}`]: true,
                    [`availability-status-box--cancelled--fill`]: this.type === 'cancelled' && this.showCancelled,
                }
            },
        },

        methods: {
            statusClicked() {
                if (this.type === 'cancelled') {
                    this.showCancelled = !this.showCancelled
                    this.emitEvent({ name: 'show-cancelled', payload: { showCancelled: this.showCancelled } })
                }
            },
        },
    }
</script>
